import "./header.scss";
import Logo from "../../assets/logo.png";
import { Link, useLocation } from "react-router-dom";
import React, { useRef, useEffect } from "react";
import { BiHomeAlt, BiMovie, BiCollection } from "react-icons/bi";

const headerNav = [
  {
    display: "Home",
    path: "/",
    icon: <BiHomeAlt />,
  },
  {
    display: "Movies",
    path: "/movie",
    icon: <BiMovie />,
  },
  {
    display: "Series",
    path: "/tv",
    icon: <BiCollection />,
  },
];

const Header = () => {
  const { pathname } = useLocation();
  const headerRef = useRef(null);

  const active = headerNav.findIndex((e) => e.path === pathname);

  useEffect(() => {
    const shrinkHeader = () => {
      if (
        document.body.scrollTop > 100 ||
        document.documentElement.scrollTop > 100
      ) {
        headerRef.current.classList.add("shrink");
      } else {
        headerRef.current.classList.remove("shrink");
      }
    };
    window.addEventListener("scroll", shrinkHeader);
    return () => {
      window.removeEventListener("scroll", shrinkHeader);
    };
  }, []);

  return (
    <div ref={headerRef} className="header">
      <div className="header__wrap container">
        <div className="logo">
          <img src={Logo} alt="" />
          <Link to="/">MirrorXSubs</Link>
        </div>
        <ul className="header__nav">
          {headerNav.map((e, i) => (
            <li key={i} className={`${i === active ? "active" : ""}`}>
              <Link to={e.path}> <i className="icon"> {e.icon} </i> <span className="path"> {e.display} </span> </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Header;
